<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  let loading = false;

  let line = "";
  let instagram = "";
  let twitter = "";

  const handleLine = (event) => {
    line = event.detail.value;
  };

  const handleInstagram = (event) => {
    instagram = event.detail.value;
  };

  const handleTwitter = (event) => {
    twitter = event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    await client.get("/sns/line").then(({ data }) => {
      console.log(data);
      if (!data.sns) {
        return;
      }
      line = data.sns.url;
    });

    await client.get("/sns/instagram").then(({ data }) => {
      if (!data.sns) {
        return;
      }
      instagram = data.sns.url;
    });

    await client.get("/sns/twitter").then(({ data }) => {
      if (!data.sns) {
        return;
      }
      twitter = data.sns.url;
    });
  });

  const saveLine = async () => {
    const client = ApiService.createClient();
    loading = true;
    await client.post("/sns", {
      name: "line",
      url: line,
    });
    await client.post("/sns", {
      name: "instagram",
      url: instagram,
    });
    await client.post("/sns", {
      name: "twitter",
      url: twitter,
    });
    loading = false;
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">SNSの設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="LINE"
      placeholder=""
      input={handleLine}
      value={line}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="Instagram"
      placeholder=""
      input={handleInstagram}
      value={instagram}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="Twitter"
      placeholder=""
      input={handleTwitter}
      value={twitter}
    />
  </div>

  <BlueButton rounded klass="mt-4" click={saveLine} {loading}>
    更新する
  </BlueButton>
</SectionBoard>
